import React from "react";
import styled from "styled-components";
import { t } from "js/i18n";
const ReadOnlyBadgeIcon = styled.div`
    background: #111827CC;
    color: white;
    padding: 6px;
    font-size: 9px;
    white-space: nowrap;
    border-radius: 3px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    line-height: 100%;
    align-self: flex-start;
`;

const ReadOnlyBadge = () => {
    return (
        <ReadOnlyBadgeIcon data-testid="view-only-badge">
            {t("view_only")}
        </ReadOnlyBadgeIcon>);
};

export default ReadOnlyBadge;
